
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document-storage-and-archiving",
      function () {
        return require("private-next-pages/document-storage-and-archiving/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document-storage-and-archiving"])
      });
    }
  